export default function LoadingSkeleton({ lines = 3, className = '' }) {
  return (
    <div className={`skeleton-group ${className}`.trim()} aria-hidden="true">
      {Array.from({ length: lines }, (_, index) => <span className="skeleton" key={index} />)}
    </div>
  )
}
